module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.send_status == 'success'),
      expression: "send_status == 'success'"
    }],
    staticClass: "alert alert-success alert-dismissible",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n    send success.\n  ")]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("New")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    class: {
      active: _vm.tab == 'by_region'
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 'by_region'
      }
    }
  }, [_vm._v("By Region")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.tab == 'by_member'
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.tab = 'by_member'
      }
    }
  }, [_vm._v("By Member")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('region-msg-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab == 'by_region'),
      expression: "tab == 'by_region'"
    }],
    attrs: {
      "msg": _vm.msg
    },
    on: {
      "onsave": _vm.regionSave
    }
  }), _vm._v(" "), _c('member-msg-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tab == 'by_member'),
      expression: "tab == 'by_member'"
    }],
    attrs: {
      "msg": _vm.msg
    },
    on: {
      "onsave": _vm.memberSave
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a4fe3318!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/new.vue
// module id = 40
// module chunks = 1